import React from "react";
import { Search, FileSignature, LineChart } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Search,
    title: "Discover",
    body: "Browse vetted infrastructure — tower portfolios, fiber routes, edge sites — with full underwriting transparency.",
  },
  {
    n: "02",
    icon: FileSignature,
    title: "Participate",
    body: "Access offerings through compliant securities structures. Investor-only, paperwork handled in-platform.",
  },
  {
    n: "03",
    icon: LineChart,
    title: "Hold & track",
    body: "Live ops dashboard for each asset: occupancy, escalators, capex, distributions. Quarterly digest.",
  },
];

const HowItWorks = () => {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative bg-neutral-950 py-28 md:py-36"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.28em] text-orange-400">
            How it works
          </p>
          <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl">
            Three steps from
            <br />
            sideline to <span className="text-orange-400">stakeholder</span>.
          </h2>
        </div>

        <div className="mt-16 grid gap-5 md:grid-cols-3">
          {steps.map((s, i) => (
            <div
              key={i}
              data-testid={`how-step-${i}`}
              className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-b from-neutral-900 to-neutral-950 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-orange-500/30"
            >
              <div className="font-display text-5xl font-bold text-neutral-800 transition-colors group-hover:text-orange-500/40">
                {s.n}
              </div>
              <div className="mt-6 grid h-12 w-12 place-items-center rounded-2xl border border-orange-500/30 bg-orange-500/10 text-orange-400">
                <s.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold text-white">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-400">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
